"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var styles = function styles(theme) {
  return {
    paginationState: {
      whiteSpace: "nowrap",
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1)
    },
    pagination: {
      fontSize: ".75rem",
      fontFamily: theme.typography.fontFamily,
      color: theme.palette.text.secondary
    },
    paginationSelect: {
      paddingRight: theme.spacing(3)
    },
    toolbar: (0, _defineProperty2.default)({}, theme.breakpoints.down("sm"), {
      justifyContent: "center",
      flexDirection: "column"
    }),
    leftButtons: {
      display: "flex"
    },
    rightButtons: {
      display: "flex"
    }
  };
};

exports.styles = styles;